// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3CFfe","info":"PatientInfo_info__1SPmO"};